module.exports = __webpack_public_path__ + "images/01686aac61952d5e03e2bc1ad52fcf77.svg";